module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAIVBMVEUAAADR09TR09TR09S8vsC8vsC8vsBVrO68vsDR09Q7iMOPeX0cAAAAB3RSTlMAUN8AUN8AOFP9RwAAAI1JREFUeF7t0bEJwzAQheGXGVJlBNXODMYjaIDscAtY8Nq40wqZMkJEYHwHVyrF/YU40NdIh9Et1UvHffmFMTyq6q1Q0uhQqBoZSC7ZKJBuPpLW+TyjQM/MXjVir6zY6CHuyD4qoI8IUlqk9bpxF4j+Z3ICirXE7mJ3E5H0Pi3p/TnKPirYfLTjlT1U1i+h/d+Beg9DwAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f3e2.png
// module id = 810
// module chunks = 0